import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import i18n, { i18nReady } from './i18n'
import './index.css'
import App from './App.tsx'

void i18nReady.then(() => {
  document.title = i18n.t('landing.pageTitle')
  document.querySelector('meta[name="description"]')?.setAttribute('content', i18n.t('landing.description'))
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
